import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateTimePickerProps from './DateTimePickerProps'

import Animation from '../Common/Animation'
import Month from '../Common/Month'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: DateTimePickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Animation,
        Month
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoDateTimePicker(that.widgetOptions)
        var widget = that.kendoWidget()

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function () {
            if(that.v3){
                that.$emit('update:modelValue', widget.value())
            } else {
                that.$emit('changemodel', widget.value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateTimePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateTimePicker/KendoDateTimePickerMixin.js